// The code in this file will load on every page of your site
import wixLocationFrontend from "wix-location-frontend";

$w.onReady(function () {
	/*
	$w("#customElement1").on("filterResults", ({ detail: { data } }) => {
		console.log(data);
		wixLocationFrontend.to(data);
	});
	*/

});